import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert,
  TextField, Box, CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import { fieldSx as compactFieldSx } from "../../egresos/components/formStyles";

const isoFecha = (value) => (value ? String(value).slice(0, 10) : "");

const initialForm = { fecha: "", num_cheque: "", monto: "", observacion: "" };

const EditarIngresoDialog = ({ open, onClose, ingresoId, onEditado }) => {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !ingresoId) return;
    setLoading(true);
    setError("");
    axios.get(`/api/caja-chica/ingresos/${ingresoId}`)
      .then(({ data }) => {
        const ingreso = data?.data;
        setForm({
          fecha: isoFecha(ingreso.fecha),
          num_cheque: ingreso.num_fac || "",
          monto: String(ingreso.monto),
          observacion: ingreso.descripcion || "",
        });
      })
      .catch((e) => setError(e?.response?.data?.message || "Error al cargar el ingreso."))
      .finally(() => setLoading(false));
  }, [open, ingresoId]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/caja-chica/ingresos/${ingresoId}`, {
        fecha: form.fecha,
        num_cheque: form.num_cheque.trim(),
        monto: Number(form.monto),
        observacion: form.observacion.trim(),
      });
      onEditado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al guardar los cambios.");
    } finally {
      setSaving(false);
    }
  };

  const puedeGuardar = form.fecha && Number(form.monto) > 0 && !saving;

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Editar Ingreso #{ingresoId}</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 1, py: 0 }}>{error}</Alert>}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={22} /></Box>
        ) : (
          <Stack spacing={0.6}>
            <TextField
              sx={compactFieldSx}
              size="small" type="date" label="Fecha de Registro" required
              InputLabelProps={{ shrink: true }}
              value={form.fecha} onChange={handleChange("fecha")}
            />
            <TextField
              sx={compactFieldSx}
              size="small" label="N° de Cheque"
              value={form.num_cheque} onChange={handleChange("num_cheque")}
            />
            <TextField
              sx={compactFieldSx}
              size="small" type="number" label="Monto" required
              value={form.monto} onChange={handleChange("monto")}
              inputProps={{ min: 0, step: "0.01" }}
            />
            <TextField
              sx={compactFieldSx}
              size="small" label="Observación"
              value={form.observacion} onChange={handleChange("observacion")}
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar || loading}>
          {saving ? "Guardando..." : "Guardar Cambios"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarIngresoDialog;
